import { Fragment } from "react"
import PropTypes from "prop-types"
import { size, map, includes } from "lodash"
import { SEARCHABLE_MENU_ITEM, LIST_ITEM_TEXT_OPTION } from "helpers/shapes"
import SearchableMenu from "components/searchable-menu"
import ListItemDropdown from "components/list-item-dropdown"
import ExcelDownload from "components/excel-download"
import { METRICS } from "helpers/metrics/constants"
import DefaultMetricUnits from "modules/default-metric-units"

import "./styles.scss"

const METRICS_WITH_CHANGEABLE_DEFAULTS = [METRICS.EXPOSURE, METRICS.PERFORMANCE]

export default function AssetsTableHeader({
  columnOrder,
  columnOrderOptions,
  downloadData,
  downloadButtonTooltip,
  menuItems,
  metricType,
  metricTypeOptions,
  selectedSubView,
  selectedView,
  setColumnOrder,
  setMetricType,
  setSelectedSubView,
  setSelectedView,
  subViewOptions,
  customActions,
  isDownloadAllowed = true,
}) {
  const { type, data, fileName } = downloadData
  const defaultMetricsListAction = includes(METRICS_WITH_CHANGEABLE_DEFAULTS, selectedView) ? <DefaultMetricUnits metric={selectedView} unit={metricType} /> : null
  return (
    <div className="components_assets-table-header">
      <div className="view-selector">
        {size(menuItems) === 1
          ? <div className="title">{selectedView}</div>
          : <SearchableMenu items={menuItems} current={selectedView} onSelect={(item) => setSelectedView(item.id)} alignMenu="left" />}
      </div>
      <div className="view-options">
        {metricTypeOptions && <ListItemDropdown label="Display" value={metricType} setValue={setMetricType} options={metricTypeOptions} alignMenu="left" listAction={defaultMetricsListAction} classes={{ toggle: "metricType" }} />}
        {subViewOptions && <ListItemDropdown label="Factor view" value={selectedSubView} setValue={setSelectedSubView} options={subViewOptions} alignMenu="left" classes={{ toggle: "factorView", popper: "factorViewPopper" }} />}
        {columnOrderOptions && <ListItemDropdown label="Column order" value={columnOrder} setValue={setColumnOrder} options={columnOrderOptions} alignMenu="left" disablePortal />}
      </div>
      <div className="custom-actions">
        {map(customActions, (node, index) => <Fragment key={`customAction-${index}`}>{node}</Fragment>)}
      </div>
      <div className="actions">
        <ExcelDownload disabled={!isDownloadAllowed} title={downloadButtonTooltip} data={data} type={type} fileName={fileName} id="table-excel-download" />
      </div>
    </div>
  )
}

AssetsTableHeader.propTypes = {
  columnOrder: PropTypes.string.isRequired,
  columnOrderOptions: PropTypes.arrayOf(LIST_ITEM_TEXT_OPTION),
  downloadData: PropTypes.object.isRequired,
  downloadButtonTooltip: PropTypes.string.isRequired,
  menuItems: PropTypes.arrayOf(SEARCHABLE_MENU_ITEM).isRequired,
  metricType: PropTypes.string,
  metricTypeOptions: PropTypes.arrayOf(LIST_ITEM_TEXT_OPTION),
  selectedSubView: PropTypes.string,
  selectedView: PropTypes.string.isRequired,
  setColumnOrder: PropTypes.func.isRequired,
  setMetricType: PropTypes.func.isRequired,
  setSelectedSubView: PropTypes.func.isRequired,
  setSelectedView: PropTypes.func.isRequired,
  subViewOptions: PropTypes.arrayOf(LIST_ITEM_TEXT_OPTION),
  customActions: PropTypes.arrayOf(PropTypes.node),
  isDownloadAllowed: PropTypes.bool,
}
